import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = circle =>
  circle ? { borderRadius: "full" } : null
